(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swish-home-shop"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sw-shop').forEach(shop=>{
 const tabs=Array.from(shop.querySelectorAll('[role="tab"]'));
 const select=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;shop.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active;});};
 tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();select(tabs[next]);tabs[next].focus();}});});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swish-q4-delivery"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-sq4-hide-after]').forEach(function(el){
    if(window.Shopify&&window.Shopify.designMode)return;
    var v=el.getAttribute('data-sq4-hide-after');if(!v)return;
    var t=Date.parse(/T/.test(v)?v:v+'T23:59:59-05:00');
    if(!isNaN(t)&&Date.now()>t)el.hidden=true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swish-q4-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function renderTiers(root){
    var list=root.querySelector('[data-sq4-tiers-list]'),fb=root.querySelector('[data-sq4-tiers-fallback]'),one=root.querySelector('[data-sq4-single]');
    var mode=root.getAttribute('data-mode')||'auto',manual=parseFloat(root.getAttribute('data-manual'));
    var st=window.SwishSaleState,tiers=st&&st.tiers||[];
    function pctOf(t){var p=parseFloat(t.pct);if(isNaN(p))p=parseFloat(String(t.vText||t.v||'').replace(/[^0-9.]/g,''));return p;}
    var big=null;
    if(tiers.length){
      if(mode==='single'||(mode==='auto'&&tiers.length===1)){big=Math.max.apply(null,tiers.map(pctOf).filter(function(x){return !isNaN(x)}));if(!isFinite(big))big=null;}
    }else if(!isNaN(manual)&&manual>0){big=manual;}
    if(big!==null){one.querySelector('b').textContent=big+'%';one.hidden=false;list.hidden=true;fb.hidden=true;return;}
    one.hidden=true;
    if(!tiers.length){list.hidden=true;fb.hidden=false;return;}
    list.textContent='';
    tiers.forEach(function(t){var li=document.createElement('li');li.className='sq4-tiers__tile';var b=document.createElement('b');b.textContent=t.vText||(pctOf(t)+'%');var s=document.createElement('small');s.textContent=t.qText||'';li.appendChild(b);li.appendChild(s);list.appendChild(li);});
    list.hidden=false;fb.hidden=true;
  }
  function tzOffset(ms){
    try{var p=new Intl.DateTimeFormat('en-US',{timeZone:'America/Toronto',timeZoneName:'shortOffset'}).formatToParts(new Date(ms)).find(function(x){return x.type==='timeZoneName'}).value;var m=/GMT([+-]\d+)(?::(\d+))?/.exec(p);if(!m)return 0;var h=parseInt(m[1],10);return (h*60+(h<0?-1:1)*parseInt(m[2]||0,10))*60000;}catch(e){return -5*3600000;}
  }
  function parseDeadline(str){
    str=String(str||'').trim();
    if(/([zZ]|[+-]\d\d:?\d\d)$/.test(str))return Date.parse(str);
    var m=/^(\d{4})-(\d\d)-(\d\d)(?:[T ](\d\d):(\d\d)(?::(\d\d))?)?/.exec(str);if(!m)return NaN;
    var utc=Date.UTC(+m[1],m[2]-1,+m[3],+(m[4]||23),+(m[5]||59),+(m[6]||0));
    return utc-tzOffset(utc);
  }
  function startCount(el){
    var end=parseDeadline(el.getAttribute('data-sq4-deadline'));if(isNaN(end))return;
    var d=el.querySelector('[data-unit=d]'),h=el.querySelector('[data-unit=h]'),m=el.querySelector('[data-unit=m]');
    function tick(){var left=Math.floor((end-Date.now())/1000);if(left<=0){el.hidden=true;clearInterval(timer);return;}d.textContent=Math.floor(left/86400);h.textContent=Math.floor(left%86400/3600);m.textContent=Math.floor(left%3600/60);}
    var timer=setInterval(tick,15000);tick();
  }
  function init(scope){
    (scope||document).querySelectorAll('[data-sq4-tiers]').forEach(renderTiers);
    (scope||document).querySelectorAll('[data-sq4-deadline]').forEach(startCount);
  }
  document.addEventListener('swish:sale-state',function(){document.querySelectorAll('[data-sq4-tiers]').forEach(renderTiers);});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();});else init();
})();

  } catch(e) { console.error(e); }
})();
})();
